package fr.frux.core.designsystem.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import fr.frux.core.designsystem.theme.FruxSpacing

@Composable
fun FruxCard(
    modifier: Modifier = Modifier,
    onClick: (() -> Unit)? = null,
    content: @Composable ColumnScope.() -> Unit,
) {
    val shape = MaterialTheme.shapes.large
    val border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant)
    val color = MaterialTheme.colorScheme.surface
    val cardContent: @Composable () -> Unit = {
        Column(modifier = Modifier.padding(FruxSpacing.md), content = content)
    }

    if (onClick != null) {
        Surface(
            onClick = onClick,
            modifier = modifier.heightIn(min = 48.dp),
            shape = shape,
            color = color,
            border = border,
            shadowElevation = 1.dp,
            content = cardContent,
        )
    } else {
        Surface(
            modifier = modifier,
            shape = shape,
            color = color,
            border = border,
            shadowElevation = 1.dp,
            content = cardContent,
        )
    }
}
